export default "__VITE_ASSET__BTPHnF7k__"